import styled, { css } from 'styled-components';
import { colors } from '@/globalStyles';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const ModalWrapperStyled = styled.div`
  width: 600px;
  outline: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${colors.white};
  border-radius: 10px;
  box-shadow: 2px 4px 16px 0 rgba(0, 0, 0, 0.25);
  padding: 30px;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css``;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const ModalBodyStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ModalFooterStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
  grid-template-rows: 60px;
`;